import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { colors } from "utils";
import { PlayIcon, StopIcon } from "../Icons";
import headphonesWarning from "assets/headphones_warning.mp3";

export const TestSpeakers = ({ activeAudioSinkId, onPlayingChange }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = new Audio(headphonesWarning);
    audioRef.current = audio;
    const handleEnded = () => {
      setIsPlaying(false);
      onPlayingChange?.(false);
    };
    audio.addEventListener("ended", handleEnded);
    return () => {
      audio.pause();
      audio.removeEventListener("ended", handleEnded);
    };
  }, [onPlayingChange]);

  useEffect(() => {
    if (audioRef.current?.setSinkId && activeAudioSinkId) {
      audioRef.current.setSinkId(activeAudioSinkId).catch(() => {});
    }
  }, [activeAudioSinkId]);

  const handleClick = () => {
    if (isPlaying) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
      onPlayingChange?.(false);
    } else {
      audioRef.current.play().catch(() => {});
      setIsPlaying(true);
      onPlayingChange?.(true);
    }
  };

  return (
    <TestSpeakersButton onClick={handleClick}>
      {isPlaying ? <StopIcon /> : <PlayIcon />}
      <TestSpeakersLabel>{isPlaying ? "Stop" : "Test Speakers"}</TestSpeakersLabel>
    </TestSpeakersButton>
  );
};

const TestSpeakersButton = styled.button`
  align-items: center;
  align-self: flex-start;
  border: 1px solid transparent;
  border-radius: 9999px;
  display: inline-flex;
  gap: 4px;
  padding: 4px 8px;
  background: transparent;
  cursor: pointer;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: ${colors.neutral300};
  }

  svg {
    flex-shrink: 0;
  }
`;

const TestSpeakersLabel = styled.span`
  color: ${colors.nightlyWoods500};
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
`;
